import { render } from "./OrganizationBackoffice.vue?vue&type=template&id=141a974f&ts=true"
import script from "./OrganizationBackoffice.vue?vue&type=script&lang=ts"
export * from "./OrganizationBackoffice.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/nicolacentonze/Desktop/Projects/cons-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__